var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinistry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.2467 1.93336L15.2467 4.33334C15.48 4.42667 15.6667 4.70667 15.6667 4.95334V7.16667C15.6667 7.53334 15.3667 7.83334 15 7.83334H3.00004C2.63337 7.83334 2.33337 7.53334 2.33337 7.16667V4.95334C2.33337 4.70667 2.52004 4.42667 2.75338 4.33334L8.75338 1.93336C8.88671 1.88002 9.11337 1.88002 9.2467 1.93336Z",
    stroke: "#B7BDB3",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6667 15.1667H2.33337V13.1667C2.33337 12.8 2.63337 12.5 3.00004 12.5H15C15.3667 12.5 15.6667 12.8 15.6667 13.1667V15.1667Z",
    stroke: "#B7BDB3",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66663 12.5V7.83333",
    stroke: "#B7BDB3",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33337 12.5V7.83333",
    stroke: "#B7BDB3",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 12.5V7.83333",
    stroke: "#B7BDB3",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 12.5V7.83333",
    stroke: "#B7BDB3",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3334 12.5V7.83333",
    stroke: "#B7BDB3",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66663 15.1667H16.3333",
    stroke: "#B7BDB3",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9 6.16667C9.55228 6.16667 10 5.71896 10 5.16667C10 4.61439 9.55228 4.16667 9 4.16667C8.44772 4.16667 8 4.61439 8 5.16667C8 5.71896 8.44772 6.16667 9 6.16667Z",
    stroke: "#B7BDB3",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinistry);
export default __webpack_public_path__ + "static/media/ministry.a394a621.svg";
export { ForwardRef as ReactComponent };